import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DocumentosProjeto } from '../../models/documentos-projeto.model';
import { DocumentosProjetoService } from '../../services/documentos-projeto.service';

@Component({
  selector: 'app-detalhe-pg-documento-edit',
  templateUrl: './detalhe-pg-documento-edit.component.html',
  styleUrls: ['./detalhe-pg-documento-edit.component.scss']
})
export class DetalhePgDocumentoEditComponent extends BaseFormComponent<DocumentosProjeto> implements OnInit {

  pg_ind_id: number;
  type: boolean;

  constructor(
    private myService: DocumentosProjetoService,
    public activatedRoute: ActivatedRoute,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pg_ind_id = this.activatedRoute.snapshot.queryParams['pg_ind_id'];
    this.myService.resolveAccordAndRedir({pg_ind_id: this.pg_ind_id}).then((data : any)=>{
		this.type = (data.pg_type_id == 1);
	});
    this.loaded();
  }

}
